﻿<template>
    <q-dialog ref="dialogRef" @hide="onDialogHide">
        <q-card class="q-dialog-plugin">
            <q-card-section class="row items-center">
                <div class="col-2 q-mr-md">
                    <q-avatar :icon="props.icon" color="primary" text-color="white"/>
                </div>
                <span class="col-9 q-ml-sm">{{ props.question }}</span>
            </q-card-section>

            <q-card-actions align="right">
                <q-btn flat :label="props.no" color="primary" @click="onDialogCancel"/>
                <q-btn flat :label="props.yes" color="primary" @click="onDialogOK"/>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script setup lang="ts">
import { useDialogPluginComponent } from "quasar"
import { ts } from "@/plugins/i18nFormat"

interface Props {
    icon?: string
    question: string
    yes?: string
    no?: string
}

const props = withDefaults( defineProps<Props>(), {
    icon: 'help',
    yes: () => ts( 'yes' ),
    no: () => ts( 'no' )
} )

defineEmits( [ ...useDialogPluginComponent.emits ] )

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
</script>
